import {
  PLATFORM_NAME,
  PLATFORM_TAGLINE,
  PLATFORM_URL,
  PLATFORM_LOGO_URL,
  PLATFORM_ORG,
} from '@/lib/branding';

/**
 * Dados estruturados (schema.org Organization) da plataforma, embutidos como
 * JSON-LD. Os robôs de classificacao de URL dos filtros corporativos
 * (Netskope, Palo Alto, Fortinet, Symantec...) e dos buscadores leem isto
 * para identificar o dominio como negocio legitimo (categoria Business),
 * evitando o bloqueio-padrao por "uncategorized". Tudo vem de PLATFORM_*
 * (branding SSOT), nada hardcoded aqui.
 */
export function PlatformOrganizationJsonLd() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: PLATFORM_NAME,
    legalName: PLATFORM_ORG.legalName,
    description: PLATFORM_TAGLINE,
    url: PLATFORM_URL,
    sameAs: [PLATFORM_ORG.corporateSite],
    logo: `${PLATFORM_URL}${PLATFORM_LOGO_URL}`,
    email: PLATFORM_ORG.email,
    telephone: PLATFORM_ORG.telephone,
    taxID: PLATFORM_ORG.taxId,
    address: {
      '@type': 'PostalAddress',
      streetAddress: PLATFORM_ORG.address.streetAddress,
      addressLocality: PLATFORM_ORG.address.addressLocality,
      addressRegion: PLATFORM_ORG.address.addressRegion,
      postalCode: PLATFORM_ORG.address.postalCode,
      addressCountry: PLATFORM_ORG.address.addressCountry,
    },
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer support',
      email: PLATFORM_ORG.email,
      telephone: PLATFORM_ORG.telephone,
      areaServed: 'BR',
      availableLanguage: ['Portuguese'],
    },
  };

  return (
    <script
      type="application/ld+json"
      // JSON serializado e seguro (sem input de usuario); dangerouslySet e o
      // padrao recomendado pelo Next para JSON-LD.
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}
